import React, {useState, useEffect} from 'react';
import './FilesUpload.css';
import { observer } from 'mobx-react';
import Sidebar from '../../components/sidebar/index.js';
import Sidebar_new from '../../components/sidebar_for_user';
import GlobalState from "../../stores/GlobalState.js";
import {Helmet} from "react-helmet";
import Dataset from '../../components/filesUpload/index.js'
import UserPool from '../../components/autorize/UserPool';
import Mini from '../../components/mini/index.js'

const FilesUpload= observer(() => {
   
    // window.onbeforeunload = () => {
    //     setholdBlock(true)
    // }
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [user, setUser]=useState("");
  
    return (
        <>
        {
            langmenu=="de"?
            <Helmet>
                <title>Beinf.ai — Hochladen historischer Datensätze</title>
                <meta name="description" content="Mit Beinf.ai ist es einfach, Kundendaten in wertvolle Business-Insights zu verwandeln. Lade deinen Datensatz für die weitere Analyse hoch." />
            </Helmet>
            :
            <Helmet>
                <title>Beinf.ai — Uploading Historical Datasets</title>
                <meta name="description" content="With Beinf.ai, it's easy to turn customer datasets into valuable business insights. Upload your dataset for further analysis." />
            </Helmet>
        }
        {
            
            user=="admin"|| user=="gewgur"?
            <>
                <Sidebar_new/>
            </>
            :
            <>
                <Sidebar/>
            </>
        }
        <div className="segmentation models hold files_upl">
           
            <div className='body_segment'>
                <Dataset/>
            </div>
        </div>
        <Mini/>
    
        </>
    );
})

export default FilesUpload;

